import React, { useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { Container } from "reactstrap";

const StyledContainer = styled.section`
  width: 100%;
  ${(props) =>
    props.width === "narrow" &&
    css`
      width: 50%;
      margin: 0 auto;
    `}
`;

export default function Flockler({ block }) {
  const containerRef = useRef(null);
  const scriptRef = useRef(null);
  console.log(block);
  useEffect(() => {
    if (scriptRef.current) return;
    if (!block.addToPage) return;
    const script = document.createElement("script");
    script.src =
      "https://plugins.flockler.com/embed/193450b53fa09fc37e523cbb6f0bcfc6/193452319e9074da7a0b3f1df9162d5f";
    script.async = true;
    script.setAttribute("data-embed-id", "193452319e9074da7a0b3f1df9162d5f");

    scriptRef.current = script;

    document.body.appendChild(script);

    return () => {
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);


  return (
    <>
      {block.maxWidth === "full" ? (
        <div
          ref={containerRef}
          id="flockler-embed-193452319e9074da7a0b3f1df9162d5f"
        />
      ) : (
        <StyledContainer width={block.maxWidth}>
          <Container>
            <div
              ref={containerRef}
              id="flockler-embed-193452319e9074da7a0b3f1df9162d5f"
            />
          </Container>
        </StyledContainer>
      )}
    </>
  );
}
